var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{attrs:{"is-enum":true,"params":_vm.params,"column":_vm.column,"id-key":_vm.idKey,"lower-case-idkey":_vm.lowerCaseIdkey,"show-value":_vm.showValue}})}
var staticRenderFns = []

export { render, staticRenderFns }